<div class="fpx-form-control" [ngClass]="{'date-disabled': formControl.disabled}">
  <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
  <box class="fpx-field-content">
    <div class="control-date-wrapper">
      <input matInput #input="ngModel" [(ngModel)]="selectedDate" [min]="minDate" [max]="maxDate" [readonly]="false"
        (dateChange)="onDatechange()" [matDatepicker]="datePicker" [ngClass]="{'input-available': selectedDate}" 
        [disabled]="formControl.disabled" />
      <mat-datepicker-toggle matSuffix [for]="datePicker" [disabled]="formControl.disabled">
        <mat-icon class="calender-icon" matDatepickerToggleIcon>calendar_month</mat-icon>
      </mat-datepicker-toggle>
      <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
      <mat-datepicker #datePicker></mat-datepicker>
    </div>
    
    <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
      {{ errorCode }}
    </mat-error>
  </box>

</div>